import Api from 'utils/api'
import i18n from 'utils/i18n'
// import {produce} from 'immer'
import {convertKeysToSnakeCase} from 'utils/helperFunctions.js'

export const flightRecordSlice = ((set, get) => ({
  flightRecords: [],

  actions: {
    checkLockedFlightRecords: () => {
      const lockedFR = get().flightRecords.find(fr => fr.locked);

      if (get().flightRecords?.length > 0 && lockedFR) return true; 

      return false;
    },
    setFlightRecords: (newFlightRecords) => {
      set((state) => ({ flightRecords: newFlightRecords}));
    },

    fetchFlightRecords: async (params, callback, errorCallback) => {
      get().actions.startLoading();
      const api = new Api();
      api.getFlightRecords(params)
        .then((response) => {
          set((state) => ({ flightRecords: response.data.flight_records}));
          try {
            callback();
          } catch (exceptionVar) {
          }
          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.stopLoading();
        try {
          errorCallback();
        } catch (exceptionVar) {
        }
        set((state) => ({ flightRecords: null}));
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
      });
    },


    saveFlightRecord: async (params, callback, errorCallback) => {
      get().actions.startLoading();
      const api = new Api();
      params = convertKeysToSnakeCase(params);
      api.saveFlightRecord(params)
        .then((response) => {
          set((state) => ({ flightRecords: [...response.data.flight_records]}));
          try {
            callback();
          } catch (exceptionVar) {
          }
          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.stopLoading();
        try {
          errorCallback();
        } catch (exceptionVar) {
        }
        set((state) => ({ flightRecords: null}));
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
      });
    },

  }

}))